<template lang="pug">
div
  div.pa-2
    div.d-flex
      div(style="margin-top: 2px;")
        div.d-flex.align-center
          v-tooltip(top color="black" content-class="black tooltip-top-arrow")
            template(#activator="{ on, attrs }")
              div(v-bind="attrs" v-on="on")
                div.text-xs.font-medium.neutral700--text.clickable.ellipsis-text-1 {{ transaction.payment_method }}
            div(style="max-width: 30vw; min-width: 60px;")
              .text-sm.white--text {{ transaction.payment_method }}
          template(v-if="transaction.channel === 'panel'")
            y-chip.no-wrap.ml-2(v-if="!transaction.panel" label="Panel" color="grey" size="xs")
            template(v-else-if="!transaction.panel_claim")
              yz-badge.ml-2(v-if="isPendingTransaction(transaction)" color="neutral-300" text-color="neutral-700" size="sm") Pending
              yz-badge.ml-2(v-else color="neutral-500" text-color="neutral-100" size="sm") Overdue
            yz-badge.ml-2(v-else :color="getBadgeColor(transaction.panel_claim.status)" :text-color="getBadgeTextColor(transaction.panel_claim.status)" size="sm") {{ transaction.panel_claim.status | capitalize }}

        div.text-xs.font-semibold(:class="isRefund ? 'danger500--text' : 'success500--text'") {{ transaction.amount | displayPrice }}
      v-spacer
      .d-flex.flex-column.ml-2
        div
          div.d-flex(v-if="transaction.documents.length")
            v-spacer
            v-card.round-md.px-2.py-1.clickable(outlined @click="showViewImagesDialog = true")
              div.d-flex.align-center
                template(v-for="(document, idx) in transaction.documents")
                  v-avatar(size="16" rounded color="neutral300" :class="idx > 0 ? 'stack-documents' : ''" :key="`dc-${idx}`")
                    template(v-if="document.type.includes('image')")
                      v-img(:src="$options.filters.smallImage(document.file)")
                    v-icon(v-else-if="document.type.includes('pdf')" color="danger500" size="15") mdi-file-pdf-box
                div.text-xs.font-medium.neutral700--text.ml-2 {{ transaction.documents.length }} images
        yz-badge.mt-1(v-if="refundStatus" :color="refundStatus === 'refunded' ? 'green-100' : 'yellow-100'" :text-color="refundStatus === 'refunded' ? 'green-700' : 'yellow-500'" size="sm") {{ refundStatus === 'refunded' ? 'Refunded' : 'Partially refunded' }}
        yz-badge.mt-1(v-if="isRefund" color="yellow-100" text-color="yellow-500" size="sm") Refund
    div.d-flex.align-center.mt-2(style="gap: 8px;")
      template(v-if="transaction.channel === 'panel'")
        y-button(label="Verify" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="showVerifyPanelDialog = true")
        template(v-if="!transaction.paid")
          y-button(v-if="!transaction.panel" label="Update claim status" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="showUpdateClaimDialog = true")
          y-button(v-else-if="!transaction.panel_claim" label="Create claim" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="onCreateClaim")
          y-button(v-else label="View claim" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="viewClaimDetails(transaction.panel_claim)")
        y-button(v-else label="View claim" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" @click="viewClaimDetails(transaction.panel_claim)")
      y-button(v-if="transaction.channel === 'self-pay'" label="Print receipt" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" text-color="neutral700" unset-min-width size="xxs" button-class="px-2" :loading="isLoadingDownloadReceipt" @click="onDownloadReceipt")
      v-spacer
      y-button(outlined height="24" color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-edit-05" icon-color="neutral700" icon-size="16" unset-min-width size="xxs" button-class="px-1" @click="onEditPayment")
      y-button(v-if="refundStatus !== 'refunded'" outlined height="24" color="neutral400" background-color="var(--v-neutral100)" prepend-icon="$yzi-trash-03" icon-color="danger500" icon-size="16" unset-min-width size="xxs" button-class="px-1" @click="showConfirmationDialog = true")

  .dialogs
    record-payment-dialog(v-if="showRecordPaymentDialog" :open.sync="showRecordPaymentDialog" :transaction="transaction" @updated="updateTransaction")
    verify-panel-dialog(v-if="showVerifyPanelDialog" :open.sync="showVerifyPanelDialog" :selectedPanel="transaction.ref_id")
    upload-photo-dialog(v-if="showUploadPhotoDialog" :open.sync="showUploadPhotoDialog" :transaction="transaction" @updated="updateTransaction")
    update-claim-dialog(v-if="showUpdateClaimDialog" :open.sync="showUpdateClaimDialog" :selected-bills="selectedBills" @updated="updateTransaction" @created="onClaimDialogCreated" @reset="onUpdateClaimDialogReset" @closed="showUpdateClaimDialog = false")
    view-images-dialog(v-if="showViewImagesDialog" :open.sync="showViewImagesDialog" :images="images")
    download-invoice-receipt-dialog(v-if="showSelectReceiptDialog" :open.sync="showSelectReceiptDialog" :documents="receiptTemplates" documentType="receipt" :transaction="transaction")
    single-claim-confirmation-dialog(v-if="showSingleClaimConfirmationDialog" v-model="showSingleClaimConfirmationDialog" @confirmed="onSingleClaimConfirmationConfirmed" @canceled="cancelClaimDialog")
    create-single-claim-dialog(v-if="showCreateSingleClaimDialog" v-model="showCreateSingleClaimDialog" :panel-name="transaction.panel.name" :panel-id="transaction.panel.id" :invoice-amount="transaction.amount" :invoice-lead-pid="transaction.lead.pid" :invoice-uid="transaction.uid" :claim-status="transaction.claim_status" :visit-date="transaction.created" @cancel="cancelClaimDialog" @created="onClaimDialogCreated")
    send-claim-dialog(v-if="showSendClaimDialog" v-model="showSendClaimDialog" :claim-id="createdClaimId" @close="onSendClaimDialogClosed")
    y-dialog(v-if="showConfirmationDialog" v-model="showConfirmationDialog" max-width=480 persistent fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-8.primary--text
          template(v-if="isDeleteRestricted")
            .d-flex.align-center
              v-icon.mr-2(color="danger500" size="18") $yzi-alert-circle
              .text-md.font-medium Unable to delete payment
            .text-sm.mt-2(v-if="isClaimReceived") This payment has a linked panel claim that has been received and cannot be deleted.
            .text-sm.mt-2(v-else) This payment has a linked panel claim and cannot be deleted. Please revert the claim to invoice first before deleting this payment.
            yz-card.mt-4.pa-3(outlined color="yz-neutral-200" style="border-radius: 10px;")
              .d-flex(style="gap: 12px;")
                .yz-medium-body-sm.text-neutral-500(style="width: 160px;") Claim number
                .d-flex.align-center(style="gap: 8px;")
                  .yz-medium-body-sm.text-neutral-700 Claim {{ `#${transaction.panel_claim.rid}` }}
                  claim-status-badge(:status="transaction.panel_claim.status")
              .d-flex.mt-3(style="gap: 12px;")
                .yz-medium-body-sm.text-neutral-500(style="width: 160px;") Payment amount
                .yz-medium-body-sm.text-neutral-700 {{ transaction.amount | displayPrice }}
          template(v-else)
            .text-md.font-medium.mb-4 Delete this payment?
            .text-sm {{ $t('click_confirm_to_proceed') }}
        v-divider
        v-card-actions.px-6.py-3
          v-spacer
          template(v-if="isDeleteRestricted")
            y-button(@click="showConfirmationDialog = false" size="sm" label="Close")
          template(v-else)
            y-button(@click="showConfirmationDialog = false" size="sm" :label="$t('cancel')" underline)
            y-button(@click="deleteTransaction" :loading="isDeleting" color="danger" :label="$t('confirm')" size="sm" dark)
    y-dialog(v-if="showNewOrThisTabDialog" v-model="showNewOrThisTabDialog" max-width="500" persistent fluid scrollable content-class="round-2xl")
      v-card
        v-card-text.pa-6
          div.d-flex.align-center
            div.text-xl.font-medium.neutral700--text Open claim {{ `#${selectedClaim.rid}` }}
            v-spacer
            v-btn(text icon @click="closeNewOrThisTabDialog")
              v-icon(color="neutral700" :size="24") mdi-close
          div.text-md.neutral700--text.mt-4 You will access claim details. Would you like to open it in this tab, or would you prefer to open a new tab instead?
        v-divider
        v-card-actions.pa-6
          v-row
            v-col
              y-button(label="This tab" color="neutral700" outlined size="md" block @click="openClaimThisTab")
            v-col
              y-button(label="New tab" text-color="neutral100" color="neutral700" size="md" block dark @click="openClaimNewTab")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import RecordPaymentDialog from '@/components/clinic/checkout/RecordPaymentDialog.vue'
import VerifyPanelDialog from '@/components/clinic/dialogs/VerifyPanelDialog.vue'
import UploadPhotoDialog from '@/components/clinic/dialogs/UploadPhotoDialog.vue'
import DownloadInvoiceReceiptDialog from '@/components/clinic/dialogs/DownloadInvoiceReceiptDialog.vue'
import UpdateClaimDialog from '@/components/clinic/dialogs/UpdateClaimDialog.vue'
import ViewImagesDialog from '@/components/dialogs/ViewImagesDialog.vue'
import CreateSingleClaimDialog from '@/components/clinic/panel/dialogs/single/CreateSingleClaimDialog.vue'
import SingleClaimConfirmationDialog from '@/components/clinic/panel/dialogs/single/SingleClaimConfirmationDialog.vue'
import SendClaimDialog from '@/components/clinic/panel/dialogs/SendClaimDialog.vue'
import ClaimStatusBadge from '@/components/clinic/panel/claims/ClaimStatusBadge.vue'

export default {
  name: 'PaymentItem',
  components: { RecordPaymentDialog, VerifyPanelDialog, UploadPhotoDialog, DownloadInvoiceReceiptDialog, UpdateClaimDialog, ViewImagesDialog, CreateSingleClaimDialog, SingleClaimConfirmationDialog, SendClaimDialog, ClaimStatusBadge },
  props: {
    transaction: {
      type: Object,
      required: true
    },
    externalEdit: {
      type: Boolean,
      default: false
    },
    activityGroup: {
      type: String,
      default: 'checkout'
    }
  },
  data: () => ({
    isDeleting: false,
    isLoadingDownloadReceipt: false,
    showRecordPaymentDialog: false,
    showVerifyPanelDialog: false,
    showConfirmationDialog: false,
    showUploadPhotoDialog: false,
    showViewImagesDialog: false,
    showUpdateClaimDialog: false,
    showSelectReceiptDialog: false,
    showNewOrThisTabDialog: false,
    showPanelMenu: false,
    showCreateSingleClaimDialog: false,
    showSingleClaimConfirmationDialog: false,
    showSendClaimDialog: false,
    selectedImage: null,
    createdClaimData: null,
    receiptTemplates: [],
  }),
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      invoice: 'treatment/getInvoice',
      leadPid: 'treatment/getLeadPid',
      isHq: 'hq/getIsHq'
    }),
    selectedBills () {
      let bills = null
      if (this.invoice.pid) {
        bills = [{
          pid: this.leadPid,
          rid: this.invoice.rid,
          record_date: this.transaction.created,
          lead: this.invoice.customer,
          products: this.invoice.products,
          transactions: [this.transaction]
        }]
      }
      return bills
    },
    images () {
      return this.transaction.documents.map(m => m.file)
    },
    createdClaimId() {
      return this.createdClaimData?.id ?? null
    },
    isClaimReceived() {
      return this.transaction.panel_claim?.status === 'received'
    },
    isDeleteRestricted() {
      return !!this.transaction.panel_claim
    },
    refundStatus () {
      const refunded = this.transaction.refunded_amount
      if (!refunded || refunded <= 0) return null
      return refunded >= this.transaction.amount ? 'refunded' : 'partial'
    },
    isRefund () {
      return this.transaction.amount < 0
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onEditPayment () {
      if (this.externalEdit) {
        this.$emit('edit', this.transaction)
      } else {
        this.showRecordPaymentDialog = true
      }
    },
    deleteTransaction () {
      this.isDeleting = true
      const endpoint = `/transactions/${this.transaction.uid}`
      this.axios.delete(endpoint)
        .then(() => {
          let activity = `Delete payment (#${this.invoice.rid})`
          this.updateOldActivityLog(endpoint, null, null, 'DELETE', this.transaction.uid, activity)
          const amount = this.$options.filters.displayPrice(this.transaction.amount, this.$currency)
          this.createActivityLog('delete_transaction', `${this.transaction.payment_method} amount ${amount} was removed`)
          this.showConfirmationDialog = false
          this.$emit('deleted')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isDeleting = false
        })
    },
    async onDownloadReceipt () {
      try {
        this.isLoadingDownloadReceipt = true
        let params = {
          company: this.company.id,
          categories: 'receipt'
        }
        const { data } = await this.$axios.get('/document_templates', { params })
        if (data.count > 1) {
          this.receiptTemplates = data.results
          this.showSelectReceiptDialog = true
          this.isLoadingDownloadReceipt = false
          return
        }
        if (data.count === 1) {
          this.onPrint(data.results[0])
          return
        }
        this.showMessage(['error', this.$t('error_message.create_item_first', { item: this.$t('receipt').toLowerCase() })])
        if (this.isHq) {
          return
        }
        this.$router.push('/admin/clinic/settings/document/templates')
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isLoadingDownloadReceipt = false
      }
    },
    async onPrint (item) {
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isLoadingDownloadReceipt = false
        return
      }
      let baseUrl = process.env.VUE_APP_BASE_URL
      if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
        baseUrl = 'https://api-test.yezza.io'
      } else if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      }
      const url = `${baseUrl}/invoices/${this.leadPid}/preview_document?document_template=${item.id}&transaction=${this.transaction.uid}&key=${key}`
      this.isLoadingDownloadReceipt = false
      window.open(url,'_blank')
    },
    onUpdateClaimDialogReset () {
      this.updateTransaction()
      this.showUpdateClaimDialog = false
    },
    updateTransaction (response) {
      this.$emit('updated', response)
    },
    updateOldActivityLog (endpoint, payload, response, method, id, activity) {
      let data = {
        company: this.company.id,
        object_id: id || null,
        object_ref: this.activityGroup,
        activity: activity,
        raw_data: { endpoint, payload, response, method}
      }
      this.$axios.post('/users/logs', data)
        .catch(() => {})
    },
    createActivityLog (tag, activity) {
      const payload = {
        company: this.company.id,
        app_model: 'form.lead',
        object_id: this.leadPid,
        tag,
        group: this.activityGroup,
        activity
      }
      this.$axios.post('/actions', payload).catch(() => {})
    },
    togglePanelMenu() {
      this.showPanelMenu = !this.showPanelMenu
    },
    getBadgeTextColor(status) {
      switch (status) {
        case 'cancelled':
          return 'red-500'
        case 'approved':
          return 'blue-500'
        case 'rejected':
          return 'red-500'
        case 'submitted':
          return 'yellow-500'
        case 'received':
          return 'green-500'
        default:
          return 'neutral-700'
      }
    },
    getBadgeColor(status) {
      switch (status) {
        case 'cancelled':
          return 'red-100'
        case 'approved':
          return 'blue-100'
        case 'rejected':
          return 'red-100'
        case 'submitted':
          return 'yellow-100'
        case 'received':
          return 'green-100'
        default:
          return 'neutral-300'
      }
    },
    viewClaimDetails(claim) {
      this.selectedClaim = claim
      this.showNewOrThisTabDialog = true
    },
    openClaimThisTab () {
      this.$router.push(`/admin/clinic/panels/claim/${this.selectedClaim.id}`)
    },
    openClaimNewTab () {
      const link = this.$router.resolve(`/admin/clinic/panels/claim/${this.selectedClaim.id}`)
      window.open(link.href, '_blank')
      this.closeNewOrThisTabDialog()
    },
    closeNewOrThisTabDialog () {
      this.showNewOrThisTabDialog = false
      this.selectedClaim = null
    },
    onCreateClaim() {
      if (this.transaction.panel?.submission_type === 'bulk') {
        this.showSingleClaimConfirmationDialog = true
      } else {
        this.showCreateSingleClaimDialog = true
      }
    },
    cancelClaimDialog() {
      this.showCreateSingleClaimDialog = false
      this.showSingleClaimConfirmationDialog = false
    },
    onClaimDialogCreated(claimData) {
      this.createdClaimData = claimData
      this.showSendClaimDialog = true
    },
    onSingleClaimConfirmationConfirmed() {
      this.showCreateSingleClaimDialog = true
    },
    onSendClaimDialogClosed() {
      this.createdClaimData = null
      this.updateTransaction()
    },
    isPendingTransaction(transaction) {
      const submissionDue = new Date(transaction.submission_due)
      const now = new Date()
      return now <= submissionDue
    }
  }
}
</script>

<style lang="scss" scoped>
.stack-documents {
  margin-left: -6px;
}
</style>